import * as React from 'react';

interface Props {
    lat: any,
    lng: any,
    nazwa: string
}

// Połowa wysokości i szerokości widocznego obszaru w stopniach (ok. 300 m wokół sklepu).
const ROZPIETOSC_LAT = 0.003;
const ROZPIETOSC_LNG = 0.006;

const naLiczbe = (wartosc: any) =>
    (wartosc === null || wartosc === undefined || wartosc === '') ? NaN : Number(wartosc);

// Mapa OpenStreetMap osadzona w ramce — bez klucza API i bez opłat.
export const MapaOsm = (props: Props) => {
    const lat = naLiczbe(props.lat);
    const lng = naLiczbe(props.lng);
    if (!isFinite(lat) || !isFinite(lng)) return null;

    const obszar = [lng - ROZPIETOSC_LNG, lat - ROZPIETOSC_LAT, lng + ROZPIETOSC_LNG, lat + ROZPIETOSC_LAT]
        .map((v) => v.toFixed(6)).join(',');
    const adresMapy = `https://www.openstreetmap.org/export/embed.html?bbox=${obszar}&layer=mapnik&marker=${lat},${lng}`;
    const adresWiekszejMapy = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`;

    return <div className={'mapa-osm mt-2 mb-4'}>
        <iframe title={`Mapa: ${props.nazwa}`} src={adresMapy} loading={'lazy'}
                style={{width: '100%', height: '300px', border: 0}}/>
        <a href={adresWiekszejMapy} target={'_blank'} rel={'noopener noreferrer'}>
            Otwórz większą mapę w OpenStreetMap (otwiera się w nowej karcie)
        </a>
    </div>
}

export default MapaOsm
